import { computed } from 'vue';
import { useRoute, useRouter } from '#app/composables/router';

export interface UsePageTabsOptions {
	metaKey: string;
	routeName: string;
	/**
	 * The default tab key that is used.
	 */
	defaultTab: string;
	/**
	 * If set to true it will omit the default tab key when constructing the route name,
	 * so `some-route-name` with the default tab `general` will become `some-route-name` and not `some-route-name-general`.
	 *
	 * @default true
	 */
	omitDefaultTabKey?: boolean;

	/**
	 * The separator to use between the route name and the suffix
	 *
	 * @default '-'
	 */
	separator?: string;
}

export function useCurrentTab({ metaKey, routeName, defaultTab, omitDefaultTabKey, separator }: UsePageTabsOptions) {
	const route = useRoute();
	const router = useRouter();
	omitDefaultTabKey ??= true;
	separator ??= '-';

	const currentTab = computed<string>({
		get() {
			return route.meta[metaKey] as string ?? defaultTab;
		},
		set(value) {
			const suffix = omitDefaultTabKey && value === defaultTab ? '' : `${separator}${value}`;

			router.replace({
				name: `${routeName}${suffix}`,
			});
		},
	});

	return { currentTab };
}
